import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { Spin, Carousel } from 'antd';
import WonderGameSlider from '../components/WonderGameSlider';
import Loader from '../components/Loader';
import GutenContent from '../components/GutenContent';

const About = () => {
    const [aboutpagedata, setAboutpagedata] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        getAboutdata()
    }, []);

    const getAboutdata = () => {
        axios.get('pages/263?acf_format=standard')
            .then((response) => {
                console.log(response.data)
                setAboutpagedata(response.data)
                setLoading(false)
            })
    }

    return (
        <div>
            {
                loading ? <Loader /> :
                    <>
                        {/* page heading */}
                        <div className='spacer'>
                            <p className='large-gradient-heading brand-text'>{aboutpagedata.title.rendered}</p>
                        </div>

                        <div className='spacer'>
                            <GutenContent htmldata={aboutpagedata.content.rendered} />
                        </div>

                        <p className='brand-text text-center gradient-small bottom15px'>
                            Yancha: Because the Future Starts at Home
                        </p>
                    </>
            }
        </div>
    )
}

export default About